<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">{{ title }}</div>
    <!-- 地址列表 -->
    <div class="mainBox">
      <div class="mainBox_title">
        建议您时常进行下列安全设置，以确保账户及交易安全。
      </div>
      <div class="line"></div>
      <div class="mainBox_list">
        <div class="mainBox_listLeft">
          <div class="circle"></div>
          <div class="mainBox_listTitle">登录密码</div>
          <div class="mainBox_listText">
            为了您的账号安全，建议定期修改密码，做到有备无患
          </div>
        </div>
        <el-link
          type="primary"
          :underline="false"
          style="
            font-size: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          "
          @click="gotoDetails('/changePassword')"
          >修改</el-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    gotoDetails(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/editPassword";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/editPassword.vue